// this gets updated automatically
export const version = '2.6.0';



//////////////////
// WEBPACK FOOTER
// ./node_modules/chroma-js/src/version.js
// module id = 2494
// module chunks = 6